import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class AddonBanner extends Component {
  
  render() {
    return(
      <div className="banner tailor">
        <h1 className="title">
          Need help making your idea?
        </h1>
        <h3 className="subtitle">
          Request our agency services to help you build and launch your platform
        </h3>
        <a class="btn" href="https://surveys.hotjar.com/s?siteId=1061910&surveyId=125729" target="_blank" rel="noreferrer nofollow">Become A Client</a> 
      </div>
    );
  }
}

export default AddonBanner;


// WEBPACK FOOTER //
// ./src/components/TailorBanner.js